module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-details-container"
  }, [_c('task-details-header', {
    on: {
      "passRecruitType": _vm.getRecruitType,
      "viewStatusId": _vm.getViewStatus,
      "passRequirement": _vm.getRequirement,
      "allowOperate": _vm.getAllowOperate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "task-requirement-wrapper"
  }, [(_vm.recruitType === 2) ? _c('span', {
    staticClass: "requirement-label"
  }, [_vm._v(_vm._s(_vm.$t('comb.additionRequirement')))]) : _vm._e(), _vm._v(" "), (_vm.recruitType === 1) ? _c('span', {
    staticClass: "recommend-label"
  }, [_vm._v(_vm._s(_vm.$t('comb.recommendAnchor')))]) : _vm._e(), _vm._v(" "), (_vm.recruitType === 2) ? _c('span', {
    ref: "requirement",
    staticClass: "task-requirement"
  }, [_vm._v("\n            " + _vm._s(_vm.requirement) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.anchors), function(anchor) {
    return _c('audition-item', {
      attrs: {
        "imgUrl": _vm.getHeadIcon(anchor.logoPic),
        "anchorName": anchor.nickname,
        "fansCount": anchor.fansCount,
        "duration": anchor.candidateDto.duration,
        "auditionDate": anchor.candidateDto.createTime,
        "description": anchor.candidateDto.comment,
        "audioUrl": anchor.candidateDto.defaultUrl,
        "waveUrl": anchor.candidateDto.waveForm,
        "status": anchor.candidateDto.offerStatusId,
        "fileId": anchor.candidateDto.fileId,
        "anchorId": anchor.uid,
        "canInvite": _vm.canInvite,
        "requirementId": _vm.requirementId,
        "candidateId": anchor.candidateDto.candidateId,
        "recruitmentType": _vm.recruitType,
        "isPlayed": anchor.candidateDto.isPlayed,
        "offerRejectedReason": anchor.candidateDto.offerRejectedReason,
        "allowOperate": _vm.allowOperate,
        "anchorGrade": anchor.anchorGrade,
        "anchorType": anchor.verifyType
      },
      on: {
        "sendAudition": _vm.sendAudition
      }
    })
  }), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "pagination-block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e42dc47!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/taskManagement/TaskDetailsMass.vue
// module id = 1083
// module chunks = 0